import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoClienteGrupoEconomicoSelectComponent } from './novo-cliente-grupo-economico-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoClienteGrupoEconomicoSelectComponent],
  exports: [NovoClienteGrupoEconomicoSelectComponent]
})
export class NovoClienteGrupoEconomicoSelectModule {}
